export default "__VITE_ASSET__BblNd7r___"